// 📁 src/lightversion/components/LiteLearningBlock.jsx

import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import { motion } from "framer-motion";
import liteLearningContent from "../config/liteLearningContent";

const LiteLearningBlock = ({ day }) => {
  const content = liteLearningContent[day];
  const storageKey = `lite_learning_viewed_day_${day}`;

  const [open, setOpen] = useState(false);
  const [hasViewed, setHasViewed] = useState(false);

  useEffect(() => {
    const viewed = localStorage.getItem(storageKey);
    if (viewed === "true") {
      setHasViewed(true);
    }
  }, [storageKey]);

  if (!content) return null;

  const handleOpen = () => {
    setOpen(true);
    localStorage.setItem(storageKey, "true");
    setHasViewed(true);
  };

  return (
    <Box sx={{ mt: 4 }}>
      {!open && (
        <Button
          variant="text"
          size="small"
          onClick={handleOpen}
          sx={{ textTransform: "none" }}
        >
          🧠 Need a quick nudge?
        </Button>
      )}

      {open && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <Card
            sx={{
              mt: 2,
              backgroundColor: "#f9fafb",
              border: "1px solid #e5e7eb",
            }}
          >
            <CardContent>
              <Typography fontWeight="bold" sx={{ mb: 1 }}>
                {content.concept}
              </Typography>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {content.explanation}
              </Typography>

              <Divider sx={{ my: 2 }} />

              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                {content.framework.title}
              </Typography>

              <Box component="ul" sx={{ pl: 2, mb: 2 }}>
                {content.framework.points.map((point, index) => (
                  <li key={index}>
                    <Typography variant="body2">{point}</Typography>
                  </li>
                ))}
              </Box>

              <Divider sx={{ my: 2 }} />

              <Typography variant="body2" fontWeight="bold">
                Apply now
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {content.applyPrompt}
              </Typography>

              {hasViewed && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", mt: 2 }}
                >
                  You can revisit this anytime.
                </Typography>
              )}
            </CardContent>
          </Card>
        </motion.div>
      )}
    </Box>
  );
};

export default LiteLearningBlock;
